<div class="datetime-calendar-component">
  <div class="fields">
    <div class="field">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        font-weight="regular"
        text-color="neutrals-600"
      >
        Desde:
      </ui-paragraph>
      <input
        type="text"
        readonly
        [value]="formatDate(range.value.start)"
        (click)="setActive('start')"
        placeholder="Seleccionar fecha"
      />
    </div>

    <div class="field">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        font-weight="regular"
        text-color="neutrals-600"
      >
        Hasta:
      </ui-paragraph>
      <input
        type="text"
        readonly
        [value]="formatDate(range.value.end)"
        (click)="setActive('end')"
        placeholder="Seleccionar fecha"
      />
    </div>
  </div>

  <div class="calendar-container">
    <div class="calendar-header">
      <button type="button" class="nav" (click)="prevMonth()">‹</button>
      <div class="month-year">
        {{ formatMonthYear() }}
      </div>
      <button type="button" class="nav" (click)="nextMonth()">›</button>
    </div>

    <div class="days-grid">
      <button
        *ngFor="let day of calendarDays"
        type="button"
        class="day"
        [class.other-month]="day.getMonth() !== displayedMonth"
        [class.in-range]="isInRange(day)"
        [class.start]="isStart(day)"
        [class.end]="isEnd(day)"
        (click)="onDateSelected(day)"
        [attr.aria-pressed]="isStart(day) || isEnd(day)"
      >
        {{ day.getDate() }}
      </button>
    </div>
  </div>

  <div class="actions">
    <button class="select-btn" type="button" (click)="submit()">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        font-weight="semibold"
        text-color="neutrals-000"
      >
        Seleccionar
      </ui-paragraph>
    </button>
  </div>
</div>
